import React from 'react';
import MagicForm from '../../Form/MagicForm';
import { ItemScheme } from '../../Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';
import usePatientConsent from '../../PatientProfile/Hooks/usePatientConsent';
import { SelectValue } from '../../Base/Select/Select';
import { useMedicalReportDefaultData } from '../../../Modules/MedicalReport/Hooks/useMedicalReportDefaultData';

export interface MedicalReportDetailGermanyFormValues {
	diagnosis: SelectValue;
	anamnesis: string;
	findings: string;
	therapyRecommendation: string;
}

interface Props {
	onSubmit: (values: MedicalReportDetailGermanyFormValues) => void;
	defaultData?: any;
	disableSubmit?: boolean;
	patientId: string;
	isMeddiCase: boolean;
}

const baseFormScheme: ItemScheme[] = [
	{
		type: MagicField.DIAGNOSIS_CZECH,
		key: 'diagnosis',
		title: 'component.medicalReportDetailGermanyForm.diagnosis',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'anamnesis',
		title: 'component.medicalReportDetailGermanyForm.anamnesis',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'findings',
		title: 'component.medicalReportDetailGermanyForm.findings',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'therapyRecommendation',
		title: 'component.medicalReportDetailGermanyForm.therapyRecommendation',
	},
];

const MedicalReportDetailGermanyForm: React.FC<Props> = ({
	onSubmit,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);
	const { formDefaultData } = useMedicalReportDefaultData({
		isMeddiCase,
		defaultData,
		isConsentProvided,
	});

	const formSchemeWithConsent: ItemScheme[] = [
		...baseFormScheme,
		{
			type: MagicField.WHITESPACE,
		},
		{
			type: MagicField.CHECKBOX,
			key: 'addToPatientECard',
			title: 'component.medicalReport.sendToPatient',
			settings: {
				disabled: isMeddiCase,
			},
		},
	];

	const handleSubmit = async (values: MedicalReportDetailGermanyFormValues) => {
		onSubmit(values);
	};

	const formSchemeWithoutConsent: ItemScheme[] = [
		...baseFormScheme,
		{
			type: MagicField.PATIENT_CONSENT_REQUEST,
			settings: {
				patientId,
			},
		},
		{
			type: MagicField.WHITESPACE,
		},
	];

	return (
		<MagicForm
			formScheme={
				isConsentProvided ? formSchemeWithConsent : formSchemeWithoutConsent
			}
			onSubmit={handleSubmit}
			defaultValues={formDefaultData}
			disableSubmit={disableSubmit}
		/>
	);
};

export default MedicalReportDetailGermanyForm;
